module.exports = __webpack_public_path__ + "static/smi1-dae146e5bcd3cbdc9a88b55ba212f2a4.png";